<script setup>
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  caseData: { type: Object, required: true },
});

const emit = defineEmits([
  'changeStatus',
  'requestCorrection',
  'requestNucleo',
]);
const { t } = useI18n();

const formatDateTime = value => {
  if (!value) return t('POST_SALE.COMMON.NO_DATE');
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
};
</script>

<template>
  <section class="rounded-lais border border-lais-border-soft bg-white p-4">
    <div class="flex items-center justify-between gap-3">
      <h2 class="font-redHatDisplay text-lg font-semibold text-lais-text">
        {{ t('POST_SALE.DETAIL.HISTORY') }}
      </h2>
      <LaisPrimaryButton
        v-if="caseData.permissions?.can_request_nucleo"
        variant="ghost"
        icon="i-lucide-file-plus-2"
        @click="emit('requestNucleo')"
      >
        {{ t('NUCLEO_WORK_ORDERS.REQUEST.ACTIONS.OPEN') }}
      </LaisPrimaryButton>
      <LaisPrimaryButton
        v-if="caseData.permissions?.can_request_correction"
        variant="ghost"
        icon="i-lucide-undo-2"
        :disabled="caseData.status === 'correcao'"
        @click="emit('requestCorrection')"
      >
        {{ t('POST_SALE.ACTIONS.RETURN_SALE') }}
      </LaisPrimaryButton>
      <LaisPrimaryButton
        v-if="caseData.permissions?.can_manage"
        icon="i-lucide-arrow-right-left"
        @click="emit('changeStatus')"
      >
        {{ t('POST_SALE.ACTIONS.CHANGE_STATUS') }}
      </LaisPrimaryButton>
    </div>
    <ol class="mt-4 divide-y divide-lais-border-soft">
      <li v-for="event in caseData.events || []" :key="event.id" class="py-3">
        <div class="flex flex-wrap items-center justify-between gap-2">
          <p class="font-semibold text-lais-text">
            {{ event.to_status_label || event.event_type }}
          </p>
          <time class="text-xs text-lais-text-muted">
            {{ formatDateTime(event.occurred_at) }}
          </time>
        </div>
        <p v-if="event.reason" class="mt-1 text-sm text-lais-text-body">
          {{ event.reason }}
        </p>
        <p v-if="event.actor?.name" class="mt-1 text-xs text-lais-text-muted">
          {{ event.actor.name }}
        </p>
      </li>
      <li
        v-if="!(caseData.events || []).length"
        class="py-5 text-sm text-lais-text-muted"
      >
        {{ t('POST_SALE.EMPTY.HISTORY') }}
      </li>
    </ol>
  </section>
</template>
